var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('router-view'),_c('OfflineSyncStatus')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }